import { ReactNode } from "react";

import { Tooltip } from "@mui/material";

import { FaIcon } from "@features/ui";
import { cn } from "@utils/tailwind";

const REYES_ADDRESS_TOOLTIP = "Reyes Address";

type AddressNameLabelProps = {
  children: ReactNode;
  isForReyes?: boolean;
  className?: string;
};

/** Renders address name text with a Reyes crown suffix when applicable. */
export const AddressNameLabel = ({
  children,
  isForReyes,
  className,
}: AddressNameLabelProps) => (
  <span
    className={cn(
      "inline-flex items-center gap-1 min-w-0 max-w-full",
      className
    )}
  >
    <span className="truncate">{children}</span>
    {isForReyes && (
      <Tooltip title={REYES_ADDRESS_TOOLTIP} placement="top">
        <FaIcon
          icon="crown"
          variant="solid"
          role="img"
          aria-label={REYES_ADDRESS_TOOLTIP}
          className="text-yellow-500 flex-shrink-0"
        />
      </Tooltip>
    )}
  </span>
);
